import styled from "@emotion/styled";
import React, {
  DetailedHTMLProps,
  FC,
  HTMLAttributes,
  ReactElement,
} from "react";
import { Box, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextIconButton from "@components/TextIconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Container = styled.div`
  margin: 32px 0 0;
  width: 100%;
`;

const OnboardingFormActionContainer: FC<
  {
    isSubmitting?: boolean;
    onPrevious?: () => void;
    onSubmit?: () => void;
    children?: ReactElement;
  } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ isSubmitting, onPrevious, onSubmit, children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Container {...props}>
      <Divider variant="fullWidth" flexItem />
      <Box
        display="flex"
        justifyContent="space-between"
        gap="16px"
        margin="24px 0 0"
        width="100%"
      >
        {children || (
          <>
            <Box>
              {onPrevious && (
                <TextIconButton
                  disabled={isSubmitting}
                  onClick={onPrevious}
                  variant="outlined"
                  icon={ArrowBackIcon}
                  text={t("onboarding.previousButton")}
                  iconLeft={true}
                />
              )}
            </Box>
            <Box>
              <TextIconButton
                type={onSubmit ? "button" : "submit"}
                onClick={onSubmit}
                disabled={isSubmitting}
                variant="contained"
                size="large"
                icon={ArrowForwardIcon}
                text={t("onboarding.continueButton")}
              />
            </Box>
          </>
        )}
      </Box>
    </Container>
  );
};

export default OnboardingFormActionContainer;
